import debounce from 'lodash.debounce';
import { getWindowWidth, getWindowHeight } from './utilities/functions';
import MobileMenu from './MobileMenu';

let currentWidth = getWindowWidth();
let currentHeight = getWindowHeight();

const mobileNavContain = document.getElementById('site-nav');
const mobileNavToggle = document.getElementById('site-nav-toggle');
const mobileNavList = document.getElementById('site-nav-list');
const mobileNavStatus = document.querySelector('.site-nav__status');

const mobileMenu = new MobileMenu(
    mobileNavContain,
    mobileNavToggle,
    mobileNavList,
    '.site-nav__link',
    'is_active',
    'is_active',
    mobileNavStatus
);

window.addEventListener('resize', debounce(() => {
    const newWidth = getWindowWidth();
    const newHeight = getWindowHeight();

    if (
        (newHeight !== currentHeight && newWidth === currentWidth)
        || (newWidth === currentWidth)
    ) {
        return false;
    }

    currentWidth = newWidth;
    currentHeight = newHeight;

    if (newWidth < 768) {
        mobileMenu.init();
    }

    if (newWidth >= 768) {
        mobileMenu.destroy();
    }
}, 500));

window.addEventListener('load', debounce(() => {
    document.body.classList.add('is_loaded');

    if (currentWidth < 768) {
        mobileMenu.init();
    }
}, 500));
